import styled from 'styled-components';
import backgroundimage from '../../../media/images/BUSINESSENQUIRY.jpg';
import imgback from '../../../media/images/news_bg.png';
import ContentBar from './ContentBar';
import FormBox from './FormBox';

const Container = styled.div`
  flex: 1;
`;

const TitleBarBackground = styled.div`
  display: flex;
  padding: 21px;
  justify-content: center;
  background-image: url(${imgback});
  background-size: cover;
  background-position: center;

  @media (max-width: 850px) {
    padding-left: 13px;
    padding-top: 13px;
    padding-bottom: 8px;
    padding-right: 5px;
  }
`;

const TitleWidth = styled.div`
  width: 1000px;
`;

const Title = styled.span`
  color: #fff;
  font-size: 2rem;
`;

const Background = styled.div`
  display: flex;
  background-image: url(${backgroundimage});
  background-size: cover;
  background-position: center bottom;
  padding-bottom: 30px;
  flex-direction: column;
`;

const ArrowDiv = styled.div`
  background: transparent;
  justify-content: center;
  display: flex;
  position: relative;
`;

const Arrow = styled.div`
  border-top-width: 35px;
  width: 0px;
  height: 0px;
  border-left-width: 45px;
  border-right-width: 45px;
  border-bottom-width: 0px;
  border-style: solid;
  background: transparent;
  border-left-color: transparent;
  border-right-color: transparent;
  position: absolute;
  color: rgba(253, 152, 15, 0.93);

  @media (max-width: 850px) {
    border-top-width: 30px;
    border-left-width: 40px;
    border-right-width: 40px;
    color: #fd980f;
  }
`;

const MaxWidth = styled.div`
  max-width: 1400px;
  width: 100%;
  display: flex;
  background-color: #fff;
  position: relative;
  align-items: center;
  height: 100%;

  @media (max-width: 980px) {
    flex-grow: 1;
    justify-content: center;
  }
`;

const MaxContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  -ms-overflow-style: none;
  scrollbar-width: none;

  iframe {
    border: none;
  }
`;

const IFrameWrapper = styled.div`
  iframe {
    border: none;
  }

  height: 100%;
`;

export {
  Container,
  TitleBarBackground,
  TitleWidth,
  Title,
  Background,
  ContentBar,
  FormBox,
  ArrowDiv,
  Arrow,
  IFrameWrapper,
  MaxWidth,
  MaxContainer,
};
